import { pipe, prop, propOr } from 'ramda';
import { RootState } from 'src/reducers';
import { Posts } from 'src/blog-item/types';

const selectAllBlogItemState = prop('blogItem');

export const selectPostBySlug = (state: RootState, slug: string) =>
  pipe(selectAllBlogItemState, prop(slug))(state);

export const selectIsLoading = (state: RootState, slug: string) =>
  pipe(selectPostBySlug, propOr(false, 'isLoading'))(state, slug);

export const selectNormalizedPostsBySlug = (
  state: RootState,
  slugs: string[]
) => {
  const posts: Posts = {};
  slugs.forEach((slug) => {
    posts[slug] = selectPostBySlug(state, slug);
  });
  return posts;
};
